export default __webpack_public_path__ + "static/cp-buffer-d90e7ffae025d702914bac726a200287.webm";